module.exports = "<app-header (sidebarToggled)=\"toggleSidenav()\" [isMobileView]=\"isMobileView\"></app-header>\r\n\r\n<mat-sidenav-container>\r\n  <mat-sidenav #sidenav [mode]=\"navMode\" class=\"sidenav-menu\">\r\n    <app-sidebar (linkSelected)=\"toggleSidenav()\"></app-sidebar>\r\n  </mat-sidenav>\r\n  <router-outlet></router-outlet>\r\n</mat-sidenav-container>\r\n\r\n<app-footer></app-footer>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main